"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.getAlignmentStyle = exports.defaultProps = exports.default = exports.AlignmentContainer = void 0;
require("./AlignmentContainer.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * AlignmentContainer component
 *
 * @method
 * @param { AlignmentContainerProps} props
 * @returns AlignmentContainer
 */

const AlignmentContainer = props => {
  const {
    children,
    theme = defaultProps.theme,
    /* padding, alignment and backgroundColor for container based on screen size */
    xlDevice,
    lgDevice,
    mdDevice,
    smDevice
  } = props;
  if (!children) {
    return null;
  }

  /* Gets each of the alignments, backgroundColors, and paddings from each breakpoint */
  const smBackgroundColor = smDevice && smDevice.backgroundColor;
  const mdBackgroundColor = mdDevice && mdDevice.backgroundColor;
  const lgBackgroundColor = lgDevice && lgDevice.backgroundColor;
  const xlBackgroundColor = xlDevice && xlDevice.backgroundColor;
  const smDeviceAlignment = smDevice && smDevice.alignment;
  const mdDeviceAlignment = mdDevice && mdDevice.alignment;
  const lgDeviceAlignment = lgDevice && lgDevice.alignment;
  const xlDeviceAlignment = xlDevice && xlDevice.alignment;
  const smDevicePadding = smDevice && smDevice.padding;
  const mdDevicePadding = mdDevice && mdDevice.padding;
  const lgDevicePadding = lgDevice && lgDevice.padding;
  const xlDevicePadding = xlDevice && xlDevice.padding;

  /* Checks to see if component has a value for backgroundColor or padding */
  const hasBackgroundColor = smBackgroundColor || mdBackgroundColor || lgBackgroundColor || xlBackgroundColor;
  const hasPaddingSides = smDevicePadding || mdDevicePadding || lgDevicePadding || xlDevicePadding;
  const hasAlignment = smDeviceAlignment || mdDeviceAlignment || lgDeviceAlignment || xlDeviceAlignment;
  const smallAlignment = getAlignmentStyle(smDeviceAlignment);
  const mediumAlignment = getAlignmentStyle(mdDeviceAlignment);
  const largeAlignment = getAlignmentStyle(lgDeviceAlignment);
  const extraLargeAlignment = getAlignmentStyle(xlDeviceAlignment);
  const componentStyle = {
    '--alignment-sm': smDeviceAlignment ? "".concat(smallAlignment) : undefined,
    '--alignment-md': mdDeviceAlignment ? "".concat(mediumAlignment) : undefined,
    '--alignment-lg': lgDeviceAlignment ? "".concat(largeAlignment) : undefined,
    '--alignment-xl': xlDeviceAlignment ? "".concat(extraLargeAlignment) : undefined,
    '--backgroundColor-sm': smBackgroundColor ? "var( --pal-colors-".concat(theme, "-").concat(smBackgroundColor, " )") : undefined,
    '--backgroundColor-md': mdBackgroundColor ? "var( --pal-colors-".concat(theme, "-").concat(mdBackgroundColor, " )") : undefined,
    '--backgroundColor-lg': lgBackgroundColor ? "var( --pal-colors-".concat(theme, "-").concat(lgBackgroundColor, " )") : undefined,
    '--backgroundColor-xl': xlBackgroundColor ? "var( --pal-colors-".concat(theme, "-").concat(xlBackgroundColor, " )") : undefined,
    '--padding-sm': smDevicePadding ? "var(--pal-l-internal-spacer-".concat(smDevicePadding, ")") : undefined,
    '--padding-md': mdDevicePadding ? "var(--pal-l-internal-spacer-".concat(mdDevicePadding, ")") : undefined,
    '--padding-lg': lgDevicePadding ? "var(--pal-l-internal-spacer-".concat(lgDevicePadding, ")") : undefined,
    '--padding-xl': xlDevicePadding ? "var(--pal-l-internal-spacer-".concat(xlDevicePadding, ")") : undefined
  };
  const componentClassName = (0, _classnames.default)('pal-c-AlignmentContainer', {
    'pal-c-AlignmentContainer--alignment': hasAlignment,
    'pal-c-AlignmentContainer--backgroundColor': hasBackgroundColor,
    'pal-c-AlignmentContainer--paddingSides': hasPaddingSides
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    style: componentStyle
  }, children);
};

/**
 * Function to get the alignment style variable for the mixin
 * @function getVariant
 * @param { object } getAlignmentStyle - returns the proper flex setting based on the alignment received
 */
exports.AlignmentContainer = AlignmentContainer;
const getAlignmentStyle = alignment => {
  if (!alignment || alignment === undefined) {
    return;
  }
  switch (alignment) {
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
  }
};

/**
 * Property type definitions
 * @typedef AlignmentContainerProps
 * @type {object}
 * @property {node} children - object of children
 * @property {object} smDevice - The object of smDevice settings (alignment, backgroundColor, padding)
 * @property {object} mdDevice - The object of mdDevice settings (alignment, backgroundColor, padding)
 * @property {object} lgDevice - The object of lgDevice settings (alignment, backgroundColor, padding)
 * @property {object} xlDevice - The object of xlDevice settings (alignment, backgroundColor, padding)
 * @property {string} theme - sets the theme at the component level
 */
exports.getAlignmentStyle = getAlignmentStyle;
const propTypes = exports.propTypes = {
  /** The object of child components to display */
  children: _propTypes.default.node,
  /** The object of smDevice settings (alignment, backgroundColor, padding) */
  smDevice: _propTypes.default.object,
  /** The object of mdDevice settings (alignment, backgroundColor, padding) */
  mdDevice: _propTypes.default.object,
  /** The object of lgDevice settings (alignment, backgroundColor, padding) */
  lgDevice: _propTypes.default.object,
  /** The object of xlDevice settings (alignment, backgroundColor, padding) */
  xlDevice: _propTypes.default.object,
  /** sets the theme at the component level */
  theme: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} theme='default' - sets the theme at the component level
 */
const defaultProps = exports.defaultProps = {
  theme: 'default'
};
AlignmentContainer.propTypes = propTypes;
var _default = exports.default = AlignmentContainer;